import React from "react";
import { createRoot, Root } from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./App";
import store from "./store";
import { injectStore } from "~/helpers/apiHelper";
import AuthContext from "~/context/auth";
import AccessContext from "~/context/access";
import ProfileContext from "~/context/profile";
import SocketContext from "~/context/socket";
injectStore(store);

const app: React.ReactElement = (
  <Provider store={store}>
    <AuthContext>
      <AccessContext>
        <ProfileContext>
          <SocketContext>
            <App />
          </SocketContext>
        </ProfileContext>
      </AccessContext>
    </AuthContext>
  </Provider>
);

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(app);
}
